export const MODULE_NAME_ACCESS_CREDIT = 'MY_RECS_ACCESS_CREDIT';
export const MODULE_NAME_TOP_RECS = 'MY_RECS_TOP_RECS';
export const MODULE_NAME_OVERVIEW = 'HOME_PAGE';
